import { createSelector } from 'reselect'

const getCurrentDomainState = state => state.domains.currentDomain

export const getAvailableGroups = createSelector(
  getCurrentDomainState,
  state => state?.data?.groups ?? []
)
